import React, { Component } from 'react'
import _ from 'lodash'
import { Icon as TideIcon, Select, ToolTip, Button } from '@driftt/tide-core-legacy'
import SalesforceLeadRoutingRadioDisplay from './SalesforceLeadRoutingRadioDisplay'
import { isEmpty } from 'ramda'
import { LookupMethodEnum } from 'constants/SalesforceLeadRoutingConstants'

import './style.styl'

class SalesforceRoutingHeader extends Component {
  render() {
    const { className, label, overlayText } = this.props

    return(
      <div className={className}>
        <div>{label}</div>
        <ToolTip flow="up" component={overlayText}>
          <TideIcon width={15} height={15} name="info"/>
        </ToolTip>
      </div>
    )
  }
}

class SalesforceLeadRouting extends Component {

  constructor(props) {
    super(props)

    this.state = {
      salesforceLeadRoutingSettings: [],
      salesforceLeadRoutingToggles: [],
      formattedSFDCObjects: [],
      formattedAccountFields: [],
      formattedContactFields: [],
      formattedLeadFields: [],
      lookupContactByEmail: false,
      lookupAccountByWebsite: false,
      defaultSettings: [
        {
          object: "Account",
          field: "OwnerId",
          lookupMethod: LookupMethodEnum.CONTACT_EMAIL,
        }
      ]
    }
  }

  componentDidMount() {
    this.props.actions.fetchSFDCObjectList()
    this.props.actions.fetchSFDCFLeadRoutingSettings()
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      salesforceLeadRoutingSettings
    } = this.state
    
    if (this.props.sfdcObjectList !== prevProps.sfdcObjectList) {
      this.setState({
        formattedSFDCObjects: this.props.sfdcObjectList.map(object => { return { label: object, value: object }})
      }, () => {
        this.props.sfdcObjectList.forEach((element) => { this.props.actions.fetchSFDCFieldList(element)})
      }
    )}

    if (this.props.sfdcAccountFieldsList !== prevProps.sfdcAccountFieldsList) {
      this.setState({
        formattedAccountFields: this.props.sfdcAccountFieldsList.map(field => { return { label: this.cleanLabel(field.label, "Account"), value: field.name }})
      })
    }

    if (this.props.sfdcContactFieldsList !== prevProps.sfdcContactFieldsList) {
      this.setState({ 
        formattedContactFields: this.props.sfdcContactFieldsList.map(field => { return { label: this.cleanLabel(field.label, "Contact"), value: field.name }})
      })
    }

    if (this.props.sfdcLeadFieldsList !== prevProps.sfdcLeadFieldsList) {
      this.setState({ 
        formattedLeadFields: this.props.sfdcLeadFieldsList.map(field => { return { label: this.cleanLabel(field.label, "Lead"), value: field.name }})
      })
    }

    if (this.props.sfdcLeadRoutingSettings !== prevProps.sfdcLeadRoutingSettings) {
      const newSettings = this.props.sfdcLeadRoutingSettings.length === 0 ? _.cloneDeep(this.state.defaultSettings) : this.props.sfdcLeadRoutingSettings
      this.setState({ salesforceLeadRoutingSettings: newSettings })
      this.props.onSalesforceLeadRoutingSettingsUpdated(newSettings)
    }

    if (this.state.salesforceLeadRoutingToggles !== prevState.salesforceLeadRoutingToggles) {
      this.props.onSalesforceLeadRoutingTogglesUpdated(this.state.salesforceLeadRoutingToggles)
    }
  }

  cleanLabel = (fieldName, objectName) => {
    //SFDC labels the owner field as {Object} Owner but only exposes the Owner Id label through their API :(
    return fieldName === "Owner ID" ? objectName + " Owner" : fieldName
  }

  selectObject = (index, { value }) =>  {
    const settingsClone = [...this.state.salesforceLeadRoutingSettings]
    settingsClone[index].object = value
    this.setState({ salesforceLeadRoutingSettings: settingsClone },
      () => {
        this.props.onSalesforceLeadRoutingSettingsUpdated(this.state.salesforceLeadRoutingSettings)
    })
  }

  selectField = (index, { value }) => {
    const settingsClone = [...this.state.salesforceLeadRoutingSettings]
    settingsClone[index].field = value
    this.setState({ salesforceLeadRoutingSettings: settingsClone },
      () => {
        this.props.onSalesforceLeadRoutingSettingsUpdated(this.state.salesforceLeadRoutingSettings)
    })
  }

  selectAccountFindOption(index, value) {
    if(index in this.state.salesforceLeadRoutingSettings) {
      const settingsClone = [...this.state.salesforceLeadRoutingSettings]
      settingsClone[index].lookupMethod = value
      this.setState({ salesforceLeadRoutingSettings: settingsClone },
        () => {
          this.props.onSalesforceLeadRoutingSettingsUpdated(this.state.salesforceLeadRoutingSettings)
      })
    }
  }

  fieldOptions(objectType) {
    switch (objectType) {
      case 'Account':
        return this.state.formattedAccountFields
      case 'Contact':
        return this.state.formattedContactFields
      case 'Lead':
        return this.state.formattedLeadFields
      default:
        return this.state.formattedAccountFields
    }
  }
  
  fieldSelection(index) {
    return (
      (!isEmpty(this.props.sfdcLeadRoutingSettings) && this.props.sfdcLeadRoutingSettings[index].field)
    )
  }
  
  displayExistingSettingRows() {
    const tableRow = this.state.salesforceLeadRoutingSettings.map((row, index) =>
      <div key={index}>
        {this.renderTableRow(this.state.salesforceLeadRoutingSettings,
          index,
          this.selectObject,
          this.selectField)}
      </div>
    )

    return (tableRow)
  }

  addRow() {
    const settingsClone = [...this.state.salesforceLeadRoutingSettings]
    const { defaultSettings } = this.state
    settingsClone.push(_.cloneDeep(defaultSettings[0]))
    this.setState({ salesforceLeadRoutingSettings: settingsClone },
      () => {
        this.props.onSalesforceLeadRoutingSettingsUpdated(this.state.salesforceLeadRoutingSettings)
    })
  }

  deleteRow(index) {
    const settingsClone = [...this.state.salesforceLeadRoutingSettings]
    settingsClone.splice(index, 1)
    this.setState({ salesforceLeadRoutingSettings: settingsClone },
      () => {
        this.props.onSalesforceLeadRoutingSettingsUpdated(this.state.salesforceLeadRoutingSettings)
    })
  }

  renderTableRow(values, index, onObjectChange, onFieldChange) {
    const isFirst = index === 0
    const isLast = index === values.length - 1
    return <div>
      <table className="rules-dropdown-table">
        <tbody>
          <tr className="rules-row">
            <td className={isFirst ? "padded-label" : ""}>
              <label>{isFirst ? "Primary" : "Fallback"}</label>
            </td>
            <td>
              <Select
                clearable={false}
                searchable={false}
                label={isFirst && <SalesforceRoutingHeader
                  className={"rules-sfdc-object-label"}
                  label={"SFDC OBJECT"}
                  overlayText={"Salesforce Accounts, Contacts, or Leads"}
                />}
                className="rules-sfdc-object"
                placeholder="Select ..."
                value={values[index].object}
                options={this.state.formattedSFDCObjects}
                onChange={(value) => onObjectChange(index, value)}
              />
            </td>
            <td>
              <Select
                clearable={false}
                searchable={false}
                label={isFirst && <SalesforceRoutingHeader
                  className={"rules-sfdc-field-label"}
                  label={"SFDC FIELD"}
                  overlayText={"An ID field associated with the object that should map to Drift"}
                />}
                className="rules-sfdc-field"
                placeholder="Select ..."
                value={values[index].field}
                options={this.fieldOptions(values[index].object)}
                onChange={(value) => onFieldChange(index, value)}
              />
            </td>
            <td className="padded-button">
              {!isFirst &&
                <div className="delete-button"
                      onClick={() => {this.deleteRow(index)}} >
                  <TideIcon width={15} name="trash"/>
                </div>
              }
              {isLast &&
                <Button size='small'
                      type="tertiary"
                      className={"or-button" + (isFirst ? " padded-button" : "")}
                      onClick={() => {this.addRow()}}>
                      + OR
                </Button>
              }
            </td>
          </tr>
        </tbody>
      </table>
      {
        (values[index].object === 'Account') &&
          <SalesforceLeadRoutingRadioDisplay
            contactLookupChecked={values[index].lookupMethod === LookupMethodEnum.CONTACT_EMAIL}
            contactLookupOnClick={() => {this.selectAccountFindOption(index, LookupMethodEnum.CONTACT_EMAIL)}}
            accountLookupChecked={values[index].lookupMethod === LookupMethodEnum.DOMAIN}
            accountLookupOnClick={() => {this.selectAccountFindOption(index, LookupMethodEnum.DOMAIN)}}
          />
      }
    </div>
  }

  render() {
    return (
        <div className="rules-lead-routing-form">
          { this.displayExistingSettingRows() }
        </div>
      ) 
    }
  }

export default SalesforceLeadRouting



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/SalesforceFilter/SalesforceLeadRouting.js